import { render, staticRenderFns } from "./CategoryFormDialog.vue?vue&type=template&id=4e964c80&scoped=true&"
import script from "./CategoryFormDialog.vue?vue&type=script&lang=js&"
export * from "./CategoryFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFormDialog.vue?vue&type=style&index=0&id=4e964c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e964c80",
  null
  
)

export default component.exports